// extracted by css-extract-rspack-plugin
export default {"map":"MapWithStores-module__map--tASn6","mode":"MapWithStores-module__mode--JKbL0"};